import React from 'react';
import useViewLink from "v4/components/utils/ViewLink/hooks/useViewLink";
import {usePolTranslation} from "v4/hooks/usePolTranslation";

export default function ViewLink({href, className = "", title, children}) {
    const {t} = usePolTranslation();
    const {handleClick, isLoading, preventClick} = useViewLink(href);
    const finalTitle = title === undefined ? t('view_file') : title;

    return (
        <a href={href}
           className={`${className} ${isLoading ? 'disabled' : ''}`}
           onClick={isLoading ? preventClick : handleClick}
           title={finalTitle}>
            {children}
        </a>
    )
}
